import React from "react";
import AppBar from "../app-bar/app-bar";
import MyOrdersPharmacy from "../data-tables-pharmacy/orders/my-orders";
import MyOrdersDistributor from "../data-tables-distributor/orders/my-orders";
import {useUser} from "../providers/user-context";

function OrdersPage({navOpen, toggleNav}) {
    const {userFullName, tenantName, tenantType} = useUser();
    return (
        <div style={{ display: 'flex', marginTop: '60px' }}>
            <AppBar userFullName={userFullName} tenantName={tenantName} type={tenantType} navOpen={navOpen} toggleNav={toggleNav}/>
            {tenantType === "PHARMACY" ? <MyOrdersPharmacy navOpen={navOpen}/>
                : tenantType === "IMPORTER" ? <MyOrdersDistributor navOpen={navOpen}/> : ""}
        </div>
    );
}
export default OrdersPage;
